module.exports = __webpack_public_path__ + "media/images/logos/humaans-95c14e3ce979b06ab80d1b9dec9ecef3.png";